import { useState } from "react";

const HirePageButton = ({ button, buttonName, onClick }) => {
  const { defaultColor, hover } = button;
  const [changeStyle, setChangeStyle] = useState(false);
  return (
    <button
      className="text-white font-semibold text-center border-0 rounded-lg md:rounded lg:rounded-lg text-lg py-4 px-8 md:px-4 lg:px-10"
      style={changeStyle ? { background: hover } : { background: defaultColor }}
      onClick={onClick}
      onMouseEnter={() => setChangeStyle(true)}
      onMouseLeave={() => setChangeStyle(false)}
    >
      <span>{buttonName}</span>
    </button>
  );
};
export default HirePageButton;
